import { withStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';

export const CssTextFieldTitle = withStyles({
    root: {
        "& .MuiInputBase-root.Mui-disabled": {
            "& > fieldset": {
                borderColor: "white",
                color: 'black',
                fontFamily: "Segoe UI !important",
            }
        },
        '& .MuiOutlinedInput-root': {
            fontWeight: 'normal',
            fontSize: '13px',
            fontFamily: "Segoe UI !important",
            '& fieldset': {
                borderColor: "white",
                color: 'black',
                fontWeight: 'normal',
                fontSize: '13px',
            },
            '&:hover fieldset': {
                borderColor: "#FFFFFF",
            },
            '&.Mui-focused fieldset': {
                borderColor: '#FFFFFF'
            },
        },
    },
})(TextField);

export const CssTextField = withStyles({
    root: {
        "& .MuiInputBase-root.Mui-disabled": {
            "& > fieldset": {
                borderColor: "white",
                color: 'black',
                fontFamily: "Segoe UI !important",
            }
        },
        '& .MuiOutlinedInput-root': {
            fontWeight: 'normal',
            fontSize: '13px',
            fontFamily: "Segoe UI !important",
            '& fieldset': {
                borderColor: "white",
                color: 'black',
                fontWeight: 'normal',
                fontSize: '13px',
            },
            '&:hover fieldset': {
                borderColor: "#E6E6E6",
            },
            '&.Mui-focused fieldset': {
                borderColor: '#E6E6E6 !important'
            },
        },
    },
})(TextField);

export const CssTextFieldRow = withStyles({
    root: {
        "& .MuiInputBase-root.Mui-disabled": {
            "& > fieldset": {
                borderColor: "white",
                color: 'black',
                fontFamily: "Segoe UI !important",
            }
        },
        '& .MuiOutlinedInput-root': {
            fontWeight: 'normal',
            fontSize: '13px',
            fontFamily: "Segoe UI !important",
            '& fieldset': {
                borderColor: "white",
                color: 'black',
                fontWeight: 'normal',
                fontSize: '13px',
            },
            '&:hover fieldset': {
                borderColor: "white",
            },
            '&.Mui-focused fieldset': {
                borderColor: 'white !important'
            },
        },
    },
})(TextField);

export const CssTextFieldLast = withStyles({
    root: {
        '& .MuiOutlinedInput-root': {
            fontWeight: 'normal',
            fontSize: '13px',
            fontFamily: "Segoe UI !important",
            '& fieldset': {
                borderColor: "#E6E6E6",
                color: 'black'
            },
            '&:hover fieldset': {
                borderColor: "#E6E6E6",
            },
            '&.Mui-focused fieldset': {
                borderColor: '#E6E6E6'
            },
        },
    },
})(TextField);

export const CssTextFieldTons = withStyles({
    root: {
        "& .MuiInputBase-root.Mui-disabled": {
            "& > fieldset": {
                borderColor: "rgb(196, 196, 196)",
                color: 'black',
                justifyContent: "center",
                textAlign: 'center',
                fontFamily: "Segoe UI !important",
            }
        },
        '& .MuiOutlinedInput-inputMultiline': {
            textAlign: 'center !important',
        },
        '& .MuiOutlinedInput-root': {
            fontWeight: 'normal',
            fontSize: '13px',
            justifyContent: "center",
            textAlign: 'center',
            fontFamily: "Segoe UI !important",
            '& fieldset': {
                borderColor: "rgb(196, 196, 196)",
                color: 'black',
                textAlign: 'center',
                justifyContent: "center",
                fontWeight: 'normal',
                fontSize: '13px',
            },
            '&:hover fieldset': {
                borderColor: "#E6E6E6",
                justifyContent: "center",
                textAlign: 'center',
            },
            '&.Mui-focused fieldset': {
                justifyContent: "center",
                borderColor: '#E6E6E6',
                textAlign: 'center',
            },
        },
    },
})(TextField);